<script>
import { features } from '@site/data/homeContent'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'FeatureSection',
  components: { AppIcon },
  data() {
    return { features }
  },
}
</script>

<template>
  <section class="section section--dark feature-section" id="features">
    <div class="feature-section__mesh" aria-hidden="true">
      <span class="feature-section__mesh-blob feature-section__mesh-blob--1"></span>
      <span class="feature-section__mesh-blob feature-section__mesh-blob--2"></span>
    </div>
    <div class="container">
      <div class="section-head section-head--light reveal">
        <span class="section-eyebrow">核心能力</span>
        <h2>把开单收银做成一件快乐的事</h2>
        <p>六大能力模块，让审美零售的每一环都高效又轻松</p>
      </div>

      <div class="grid grid--3">
        <article v-for="(f, i) in features" :key="i" class="feature-card reveal">
          <div class="icon-badge feature-card__badge"><AppIcon :name="f.icon" /></div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </article>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.feature-section {
  position: relative;
  overflow: hidden;

  &__mesh { position: absolute; inset: 0; pointer-events: none; }
  &__mesh-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(70px);
    &--1 { width: 480px; height: 480px; top: -150px; left: 10%; background: radial-gradient(circle, rgba(236, 72, 153, 0.32), transparent 65%); }
    &--2 { width: 440px; height: 440px; bottom: -130px; right: 6%; background: radial-gradient(circle, rgba(168, 85, 247, 0.38), transparent 64%); }
  }
}

.feature-card {
  position: relative;
  z-index: 1;
  // 毛玻璃：深色 mesh 光斑之上的玻璃卡片
  background: rgba(255, 255, 255, 0.06);
  -webkit-backdrop-filter: blur(16px) saturate(160%);
  backdrop-filter: blur(16px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: $radius-lg;
  padding: 38px 34px;
  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  transition: transform $motion-base $ease-out, background $motion-base $ease-out, border-color $motion-base $ease-out, box-shadow $motion-base $ease-out;

  &:hover {
    transform: translateY(-4px);
    background: rgba(255, 255, 255, 0.09);
    border-color: rgba(168, 85, 247, 0.4);
    box-shadow: 0 14px 44px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.16);
  }

  &__badge {
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.3));
    margin-bottom: 22px;
    color: $color-secondary-light;
  }

  h3 { color: $color-white; font-size: 21px; font-weight: $weight-bold; margin-bottom: 8px; letter-spacing: -0.01em; }
  p { color: rgba(255, 255, 255, 0.66); font-size: 15px; line-height: 1.6; }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/FeatureSection.vue